export const lifestyle = [
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1662530043.20853301!256x256.jpg?f=webp",
    discount: 45,
    name: "Xiomi Grooming Kit",
    price: "1,099",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1681292640.42658518!256x256.jpg?f=webp",
    discount: 26,
    name: "Xiaomi Beard Trimmer",
    price: "2,499",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1646731200.255354!348x348.jpg?f=webp",
    discount: 72,
    name: "Redmi Watch 2 Lite",
    price: "2,199",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1626952357.85696708!256x256.jpg?f=webp",
    discount: 11,
    name: "Mi 67W SoniCharge",
    price: "1,999",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1584347658.51432077!256x256.jpg?f=webp",
    discount: 11,
    name: "Mi USB Type C Cable",
    price: "179",
  },
  {
    img: "https://i03.appmifile.com/474_item_in/12/06/2023/d6f65d9becd44f6011a21a65e6ef37ed.jpg",
    discount: 53,
    name: "Redmi Buds 4 Active",
    price: "1,399",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1662530043.20853301!256x256.jpg?f=webp",
    discount: 45,
    name: "Xiaomi Grooming Kit",
    price: "1,099",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1579000327.41389918!348x348.png?f=webp",
    discount: 57,
    name: "Xiaomi Earphones",
    price: "429",
  },
];

export const lifestyleCarouselData = [
  {
    img: "https://i03.appmifile.com/750_operator_in/28/04/2023/1e54e3830d3745fcac85919dfa23986c.jpg?f=webp",
    para1: "All in one Quality Grooming",
    name: "Xiaomi Grooming Kit",
    para2: "Multiple attachments for all your grooming needs",
    price: "1,799"
  },
  {
    img: "https://i03.appmifile.com/472_operator_in/05/08/2023/c71544740adc07d914ab99c436b7b093.jpg?f=webp",
    para1: "Call me on my",
    name: "Redmi Watch 3 Active",
    para2: "Get the Green Strap Worth ₹999 at just ₹499",
    price: "2,999"
  }
]